import { css } from "@linaria/core";
import { colors } from "../../../../Theme";
import { radius } from "../../../..";

export const DEFAULT_CLASSNAME_THEME_TABLE = css`
  position: relative;

  .textBold {
    font-weight: bold;
  }

  .textItalic {
    font-style: italic;
  }

  & > [contenteditable] {
    .tabNode {
      position: relative;
      text-decoration: none;
    }
    .tableScrollableWrapper {
      width: 100%;
      overflow-x: auto;
      /* margin: 0px 25px 30px 0px; */
    }
    .tableScrollableWrapper > .table {
      margin-top: 0;
      margin-bottom: 0;
    }
    .table {
      box-sizing: border-box;
      border-collapse: separate;
      border-spacing: 0 0;
      overflow-y: scroll;
      overflow-x: scroll;
      table-layout: fixed;
      width: fit-content;
      /* width: 100%; */
      margin-top: 25px;
      margin-bottom: 30px;

      tr:first-of-type th:first-child {
        border-top-left-radius: ${radius};
      }
      tr:first-of-type th:last-child {
        border-top-right-radius: ${radius};
      }
      tr:last-child th:first-child {
        border-bottom-left-radius: ${radius};
      }
      tr:last-child td:last-child {
        border-bottom-right-radius: ${radius};
      }

      & tr:not(:first-of-type) th:first-of-type {
        background-color: ${colors.hydrogen};
      }
    }
    .tableRowStriping tr:nth-child(even) {
      background-color: ${colors.hydrogen};
    }
    .tableSelection *::selection {
      background-color: transparent;
    }
    .tableSelected {
      outline: 2px solid rgb(60, 132, 244);
    }
    .tableCell {
      border: 1px solid ${colors.titanium200};
      width: 100%;
      vertical-align: top;
      text-align: start;
      padding: 6px 8px;
      position: relative;
      outline: none;
      overflow: auto;
    }
    .tableCell > * {
      overflow: inherit;
    }
    .tableCellResizer {
      position: absolute;
      right: -4px;
      height: 100%;
      width: 8px;
      cursor: ew-resize;
      z-index: 10;
      top: 0;
    }
    .tableCellHeader {
      background-color: ${colors.titanium100};
      text-align: start;
      font-weight: normal;
    }
    .tableCellSelected {
      caret-color: transparent;
    }
    .tableCellSelected::after {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: highlight;
      mix-blend-mode: multiply;
      content: "";
      pointer-events: none;
    }
    @keyframes table-controls {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .tableCellResizeRuler {
      display: block;
      position: absolute;
      width: 1px;
      background-color: rgb(60, 132, 244);
      height: 100%;
      top: 0;
    }
    .tableCellActionButtonContainer {
      display: block;
      right: 5px;
      top: 6px;
      position: absolute;
      z-index: 4;
      width: 20px;
      height: 20px;
    }
    .tableCellActionButton {
      background-color: ${colors.hydrogen};
      display: block;
      border: 0;
      border-radius: 20px;
      width: 20px;
      height: 20px;
      color: #222;
      cursor: pointer;
    }
    .tableCellActionButton:hover {
      background-color: ${colors.hydrogen};
    }
  }
`;
